module.exports = __webpack_public_path__ + "img/mockups.71fa2401.png";